
const ajax_url = ajaxurl['ajax_url'];

window.addEventListener("DOMContentLoaded", () => {
	const containers = document.querySelectorAll('.wp-block-welko-latest-events');
	containers.forEach((container) => {
		//Déclaration des filtres
		declare_welko_latest_events_term_filter_event(container);
		//Déclaration du loadmore
		declare_welko_latest_events_loadmore_event(container);
		//Déclaration du slider
		declare_welko_latest_events_swiper(container);
	});
});

//SLIDER
function declare_welko_latest_events_swiper(container) {
	let swiper = container.querySelector('.wp-block-welko-latest-events__list .swiper');
	if (swiper !== null) {
		let swiper_name = ".swiper_" + swiper.getAttribute('data-id');
		let nb_slide = parseInt(swiper.getAttribute('data-nb-slide'));
		let autoSlide = (/true/).test(swiper.getAttribute('data-auto-slide'));

		const swiperInstance = new Swiper(swiper_name, {
			watchSlidesProgress: true,
			spaceBetween: 30,
			autoplay: {
				delay: 3000,
				disableOnInteraction: true,
				pauseOnMouseEnter: true,
			},
			autoplay: autoSlide,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				577: {
					slidesPerView: 2,
				},
				767: {
					slidesPerView: 3,
				},
				992: {
					slidesPerView: nb_slide,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: ".swiper-pagination",
			},
		});
	}
}

//LOADMORE
function declare_welko_latest_events_loadmore_event(container) {
	const loadmores = container.querySelectorAll('.wp-block-welko-latest-events__loadmore');
	const postListContainer = container.querySelector('.wp-block-welko-latest-events__list');
	if (loadmores.length && loadmores.length > 0) {
		loadmores.forEach((loadmore) => {
			loadmore.addEventListener('click', function () {
				welko_latest_events_loadmore(postListContainer);
			});
		});
	}
}

function welko_latest_events_loadmore(postListContainer) {

	//Container du loadmore/pagination
	var postLoadmore = (postListContainer.nextElementSibling.classList.contains('wp-block-welko-latest-events__loadmore')) ? postListContainer.nextElementSibling : false;

	//Données à envoyer
	let _data = {
		action: 'welko_latest_events_loadmore',
		...postListContainer.dataset
	};

	fetch(ajax_url, {
		method: 'POST',
		body: (new URLSearchParams(_data)).toString(),
		headers: {
			'Content-type': 'application/x-www-form-urlencoded'
		}
	}).then(response => {
		if (!response.ok) throw new Error("Erreur réseau");
		return response.json();
	}).then(data => {
		// Crée un document à partir du HTML reçu
		let parser = new DOMParser();
		let doc = parser.parseFromString(data.html, 'text/html');

		// Récupère tous les éléments enfants du <body> du HTML reçu
		let elements = doc.body.children;

		// Insère chaque élément dans le conteneur
		Array.from(elements).forEach(el => {
			postListContainer.append(el);
		});

		//Mise à jour de l'offset
		let posts_per_page = postListContainer.getAttribute('data-posts_per_page');
		let offset = postListContainer.getAttribute('data-offset');
		let new_offset = parseInt(offset) + parseInt(posts_per_page);
		postListContainer.setAttribute("data-offset", new_offset);

		//Cache le loadmore caché si plus de post à afficher
		let post_count = postListContainer.getAttribute('data-post_count');
		if (parseInt(new_offset) >= parseInt(post_count)) {
			postLoadmore.style.display = "none";
		}
	});
}

//FILTRER
function declare_welko_latest_events_term_filter_event(container) {
	const filters = container.querySelectorAll('.wp-block-welko-latest-events__filters__filter');
	const postListContainer = container.querySelector('.wp-block-welko-latest-events__list');
	const selectFilter = container.querySelector('.wp-block-welko-latest-events__filters select');

	//Select
	if (selectFilter && postListContainer) {
		selectFilter.addEventListener('change', function () {
			let selectedOption = selectFilter.options[selectFilter.selectedIndex];
			let term_id = selectedOption.getAttribute('data-termid');
			welko_latest_events_term_filter(term_id, postListContainer);
		});
	}

	//UL
	if (filters.length && filters.length > 0 && postListContainer) {
		filters.forEach((filter) => {
			filter.addEventListener('click', function () {
				let term_id = filter.getAttribute('data-termid');
				welko_latest_events_term_filter(term_id, postListContainer);
				const active_filter = container.querySelector('.wp-block-welko-latest-events__filters__filter--active');
				active_filter.classList.remove('wp-block-welko-latest-events__filters__filter--active');
				filter.classList.add('wp-block-welko-latest-events__filters__filter--active');
			});
		});
	}
}

function welko_latest_events_term_filter(term_id_clicked, postListContainer) {
	//Vérification du term_id
	var term_id = (term_id_clicked != null) ? term_id_clicked : '';

	//Container de la liste des posts
	postListContainer.style.opacity = "0";

	//On récupère les attributs 'data-'
	let dataAttributes = {};
	for (let attr of postListContainer.attributes) {
		if (attr.name.startsWith('data-')) {
			// Supprime le "data-" et garde le reste tel quel
			dataAttributes[attr.name.slice(5)] = attr.value;
		}
	};

	//Container du loadmore/pagination
	var postLoadmore = (postListContainer.getAttribute('data-display_loadmore') === "loadmore") ? postListContainer.nextElementSibling : false;
	if (postLoadmore) postLoadmore.style.opacity = "0";

	//Données à envoyer
	let _data = {
		action: 'welko_latest_events_term_filter',
		...postListContainer.dataset,
		terms_id: term_id,
	};

	//Appel ajax
	fetch(ajax_url, {
		method: 'POST',
		body: (new URLSearchParams(_data)).toString(),
		headers: {
			'Content-type': 'application/x-www-form-urlencoded'
		}
	}).then(response => {
		if (!response.ok) throw new Error("Erreur réseau");
		return response.json();
	}).then(data => {
		//Modification de la liste
		postListContainer.innerHTML = data.html;
		postListContainer.style.opacity = "1";
		if (postListContainer.getAttribute('data-layout') === "slider") {
			declare_welko_latest_events_swiper(postListContainer);
		}

		//Remise à 0 de l'offset.
		let posts_per_page = postListContainer.getAttribute('data-posts_per_page');
		postListContainer.setAttribute('data-offset', posts_per_page);

		let offset = parseInt(posts_per_page);
		let count = parseInt(data.count);

		//Si loadmore, on l'affiche si d'autre post sont à charger
		if (postLoadmore && count > offset) {
			postLoadmore.style.display = "flex";
			postLoadmore.style.opacity = "1";
		}


		//Modification du term_id en cours pour les futurs loadmore/pagination
		postListContainer.setAttribute('data-terms_id', term_id);
		//Modification du post-count pour les futures loadmore/pagination
		postListContainer.setAttribute('data-post_count', count);

	});
}